module.exports = __webpack_public_path__ + "static/media/L.9837f8f0.jpg";